import React, { useEffect, useState } from "react";
import { Typography, Container, Button, Box, Tooltip, IconButton, Grid, } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import LinkIcon from "@mui/icons-material/Link";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoFileIcon from "@mui/icons-material/VideoFile";
//global css
import "../../styles/global.css";
// Result Categories RadioButton List
import ResultCategoriesRadioButtonList from "./ResultCategoriesRadioButtonList";
// Result Data checkbox list for quality parameters
import ResultDataTypeCheckboxList from "./ResultDataTypeCheckboxList";
//ResultModeHeader i.e. for Table, Graph, Help
import ResultModeHeader from "./ResultModeHeader";
//Trial Warning Modal
import ResultWarning from "./ResultWarning";
import { getApiUrl } from "../../utils/apiEndPoints";
const ResultHeader = ({ 
//trialID,
onGraphClick, onTableClick, onHelpClick, onResultCategoryClick, onDataTypeCheckboxesChanged, currentTrial, distinctResultCategories, selectedResultCategoryId, }) => {
    var _a;
    const [trial, setTrial] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentResultCategoryID, setCurrentResultCategoryID] = useState(selectedResultCategoryId !== null && selectedResultCategoryId !== void 0 ? selectedResultCategoryId : "");
    //Trial Warning modal state
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const tw = trial === null || trial === void 0 ? void 0 : trial.trialWarning;
        if (tw != null) {
            //check if not null or empty
            if (tw.length > 0 &&
                tw !== null &&
                tw !== "NULL") {
                //console.log("Trial Warning: ", trial.trialWarning);
                setOpen(true);
            }
        }
    }, [trial === null || trial === void 0 ? void 0 : trial.trialWarning]);
    const handleResultWarningClose = () => {
        setOpen(false);
    };
    //api base url
    const BaseUrl = getApiUrl();
    const filteredCategories = distinctResultCategories.filter((category) => category.categoryName !== "Total");
    const handleResultCategoryClick = (resultCategoryID) => {
        var _a;
        const ResultCategory = (_a = distinctResultCategories.find((category) => category.id === resultCategoryID)) === null || _a === void 0 ? void 0 : _a.categoryName;
        setCurrentResultCategoryID(resultCategoryID);
        if (onResultCategoryClick)
            onResultCategoryClick === null || onResultCategoryClick === void 0 ? void 0 : onResultCategoryClick(resultCategoryID, ResultCategory !== null && ResultCategory !== void 0 ? ResultCategory : "");
    };
    useEffect(() => {
        if (currentTrial) {
            setTrial(currentTrial);
            setLoading(false);
        }
    }, [currentTrial]);
    useEffect(() => {
        //if not selectedResultCategoryId then set to Seasonal id
        if (!selectedResultCategoryId) {
            const defaultCategory = distinctResultCategories.find((category) => category.categoryName === "Seasonal");
            if (defaultCategory) {
                setCurrentResultCategoryID(defaultCategory.id);
            }
            else {
                console.log("No default category found", distinctResultCategories);
                if (distinctResultCategories.length > 0)
                    setCurrentResultCategoryID(distinctResultCategories[0].id);
            }
        }
    }, [currentResultCategoryID, distinctResultCategories, selectedResultCategoryId]);
    if (loading) {
        return React.createElement(Typography, null, "Loading ...");
    }
    if (!trial) {
        return React.createElement(Typography, null, "No trial data available");
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const headerKeys = [
        [
            "Sown",
            trial.startDate
                ? formatDate(trial.startDate.toString())
                : "Not Available",
        ],
        ["Region", trial.regionName],
        ["Site", trial.siteName],
        ["Species", trial.speciesName],
        ["More Info", trial.trialDocument ? trial.trialDocument : ""],
        ["Soil Type", trial.soilTypeName ? trial.soilTypeName : ""],
        [
            "Average Rainfall (10yr)",
            trial.annualRainfall ? trial.annualRainfall.toString() + " mm" : "",
        ],
        // Irrigated
        ["Irrigated", trial.irrigated ? "Yes" : "No"],
        // TrialLength
        ["Trial Term", trial.trialLength ? trial.trialLength : ""],
    ];
    const tooltips = {
        "Soil Type": "These soils types are based on the Australian Soil Classification and can be found here: https://www.soilscienceaustralia.org.au/asc/",
        "Average Rainfall (10yr)": "Rainfall is a 10-year average from the closest BOM station to the trial.",
    };
    const returnTrialDocumentPath = (trialId) => {
        if (trialId) {
            return `${BaseUrl}Trials/trial-document?ID=${trialId}`;
        }
        else
            return "#";
    };
    function getResultCategoryName(resultCategoryID) {
        var _a;
        const resultCategory = distinctResultCategories.find((category) => category.id === resultCategoryID);
        return (_a = resultCategory === null || resultCategory === void 0 ? void 0 : resultCategory.categoryName) !== null && _a !== void 0 ? _a : "";
    }
    const handleOnDataTypeCheckboxesChanged = (listOfCheckedDataTypeIds) => {
        console.log("List of Checked Data Type IDs", listOfCheckedDataTypeIds);
        onDataTypeCheckboxesChanged(listOfCheckedDataTypeIds);
    };
    //================================================================================================
    //                      Window resize event listener
    //================================================================================================
    return (React.createElement(Container, { sx: {
            width: "100%",
            marginTop: "0px",
            padding: "0px !important",
        } },
        React.createElement(Grid
        // spacing={2}
        , { 
            // spacing={2}
            sx: {
                //align all the content to the left
                justifyContent: "left",
                alignItems: "left",
            } },
            React.createElement(Grid, { item: true, xs: 12, sx: {
                    //align all the content to the left
                    justifyContent: "left",
                    alignItems: "left",
                } },
                React.createElement(Typography, { variant: "h5", sx: { color: "#005533", marginBottom: "10px" } }, currentTrial === null || currentTrial === void 0 ? void 0 : currentTrial.name),
                React.createElement(Box, { sx: {
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "row",
                        border: "solid 1px #e3e3e3",
                        width: "100%",
                        //minWidth: "100%",
                        padding: "20px",
                        borderRadius: "5px",
                        marginBottom: "10px",
                        flexWrap: "wrap",
                    } }, headerKeys.map(([key, value]) => (React.createElement(Box, { key: key, sx: {
                        padding: "5px 20px 5px 0px",
                    } }, key === "More Info" &&
                    Array.isArray(trial.trialDocuments) &&
                    trial.trialDocuments.length > 0 ? (React.createElement("span", null,
                    React.createElement("span", { className: "resultSpan" },
                        key,
                        ":"),
                    trial.trialDocuments.filter(x => x.url).map((doc) => {
                        var _a, _b, _c, _d;
                        const mimeType = ((_a = doc.mimeType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                        const isPdf = mimeType === "application/pdf";
                        const isExternal = ((_b = doc.url) === null || _b === void 0 ? void 0 : _b.startsWith("https://")) || false;
                        const isVideo = mimeType.startsWith("video/");
                        const isTrialInfo = trial.trialCode && isPdf && ((_c = doc.name) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes((_d = trial.trialCode) === null || _d === void 0 ? void 0 : _d.toLowerCase()));
                        const icon = isPdf ? React.createElement(PictureAsPdfIcon, null) : isVideo ? React.createElement(VideoFileIcon, null) : isExternal ? React.createElement(LinkIcon, null) : null;
                        return React.createElement(Button, { key: doc.id, sx: {
                                backgroundColor: "#ffffff",
                                color: "#111111",
                                // swap colors on hover
                                "&:hover": {
                                    backgroundColor: "#f1f1f1",
                                    color: "#333333",
                                },
                                fontSize: "0.9em",
                                padding: "0px 10px",
                                margin: "0px 0px 3px 10px",
                                border: "solid 1px #005533",
                            }, startIcon: icon, component: "a", href: doc.url, target: "_blank", rel: "noopener noreferrer" }, isTrialInfo ? 'Trial' : doc.name);
                    }))) : (
                // tooltips[key] ?? (
                React.createElement(Box, { key: key, sx: {
                        display: "flex",
                        alignItems: "center",
                        margin: "0px 0px 0px 0px",
                        padding: "0px 0px 0px 0px",
                    } },
                    React.createElement(Tooltip, { title: tooltips[key] || "", sx: { display: tooltips[key] ? "block" : "none" } },
                        React.createElement(IconButton, { sx: {
                                padding: "0px 8px 8px 8px",
                                display: tooltips[key] ? "block" : "none",
                            } },
                            React.createElement(InfoIcon, { sx: { color: "#005533" } }))),
                    React.createElement(Typography, { variant: "body1", sx: { color: "#111111", padding: "0px 8px 8px 8px" } },
                        React.createElement("span", { className: "resultSpan" },
                            key,
                            ":"),
                        " ",
                        value))
                // )
                ))))))),
        React.createElement(ResultModeHeader, { onTableClick: onTableClick, onGraphClick: onGraphClick, onHelpClick: onHelpClick }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, sm: 12, xs: 12 },
                React.createElement(ResultCategoriesRadioButtonList, { trialName: trial.name, distinctResultCategories: filteredCategories, currentResultCategoryID: currentResultCategoryID, handleResultCategoryClick: handleResultCategoryClick })),
            getResultCategoryName(currentResultCategoryID) === "Quality" && (React.createElement(Grid, { item: true, sm: 12, xs: 12 },
                React.createElement(ResultDataTypeCheckboxList, { trialID: trial.id, onDataTypeCheckboxesChanged: handleOnDataTypeCheckboxesChanged, trialResultCategoryName: getResultCategoryName(currentResultCategoryID) })))),
        React.createElement(ResultWarning, { open: open, onClose: handleResultWarningClose, warningMessage: (_a = trial === null || trial === void 0 ? void 0 : trial.trialWarning) !== null && _a !== void 0 ? _a : "" })));
};
export default ResultHeader;
